module.exports = __webpack_public_path__ + "media/images/flags/64/Jordan-372dd38b608522c134f9bd6a09fe38cd.png";